import { useState, useCallback } from 'react';

export type OpenCloseProps = {
  open: boolean;
  onClose: () => void;
  onOpenChange: (isOpen: boolean) => void;
};

type UseOpenClose = () => [OpenCloseProps, () => void, () => void];

export const useOpenClose: UseOpenClose = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const onToggle = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  const onOpenChange = useCallback((isOpen: boolean) => {
    setOpen(isOpen);
  }, []);

  return [
    {
      open,
      onClose: handleClose,
      onOpenChange,
    },
    handleOpen,
    onToggle,
  ];
};
